import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import RecommendedUtilityForm from '../containers/RecommendedUtilityFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class RecommendedUtilityAddScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `RecommendedUtilityAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('recommended_utilities_route_add')} />
            <RecommendedUtilityForm />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RecommendedUtilityAddScreen;

Logger.log('silly', `RecommendedUtilityAddScreen loaded.`);
